// Week 1 / Day 1 — Money, Price and Choice (Coin Mission).
// Reworked: bilingual RU/EN inline; playful Nimny mission tone;
// 50% online + 50% paper/parent. Five layers preserved.

const day1 = {
  id: 'day-1',
  studentId: 'max',
  weekId: 'week-1',
  dayId: 'day-1',
  status: 'active',
  title: 'Миссия монеток: деньги, цена и выбор / Coin Mission: Money, Price and Choice',
  shortTitle: 'Деньги и выбор / Money and Choice',
  theme:
    'Деньги помогают сравнивать, выбирать и планировать. / Money helps us compare, choose and plan.',
  estimatedTimeLabel:
    'Онлайн-миссия: около 20–30 минут. Бумажная миссия с родителем: около 25–35 минут. / Online mission: about 20–30 minutes. Paper mission with parent: about 25–35 minutes.',
  nimnyIntro:
    'Нимни открыла маленькую ночную лавку. На полках лежат карточки: цена, нужно, хочу, обмен и выбор. Помоги Нимни понять, что действительно важно, а что можно оставить на потом. / Nimny opened a tiny night shop. On the shelves are cards: price, need, want, exchange and choice. Help Nimny decide what matters and what can wait.',
  goals: [
    'Слой 1. Математика: считать цены, сравнивать выборы и находить остаток в нимах. / Layer 1. Math: count prices, compare choices and find what is left in nims.',
    'Слой 2. Русский язык и правописание: словарь миссии, мини-диктант, безударные гласные. / Layer 2. Russian language and spelling: mission vocabulary, mini-dictation, unstressed vowels.',
    'Слой 3. Чтение, письмо и пересказ: «Почему люди используют деньги?» — план, пересказ и 3–5 предложений. / Layer 3. Reading, writing and retelling: "Why do people use money?" — plan, retell and 3–5 sentences.',
    'Слой 4. Наблюдение и логика — как выбор меняет остаток. / Layer 4. Observation and Logic — How Choice Changes What Is Left.',
    'Слой 5. Практика на бумаге: «Лавка Нимни» — карточки нужно/хочу/цена/обмен/отложить и маленький выбор на 50 нимов. / Layer 5. Paper practice: "Nimny Shop" — need/want/price/exchange/save cards and a small 50-nim choice.',
    'Дневник мышления: один умный выбор за день. / Thinking diary: one smart choice of the day.',
    'Награда нимами: базово 3 нима, максимум 5 с бонусами. / Reward in nims: 3 base, up to 5 with bonuses.'
  ],
  vocabulary: [
    { term: 'деньги / money', definition: 'знак, который принимают все, чтобы сравнивать и выбирать. / a sign accepted by all to compare and choose.' },
    { term: 'цена / price', definition: 'сколько стоит товар в нимах. / how many nims an item costs.' },
    { term: 'обмен / exchange', definition: 'когда отдают одно и получают другое. / giving one thing and getting another.' },
    { term: 'нужно / need', definition: 'без этого трудно или нельзя. / hard or impossible without it.' },
    { term: 'хочу / want', definition: 'было бы приятно, но можно подождать. / nice to have, but can wait.' },
    { term: 'выбор / choice', definition: 'когда сравниваешь и берёшь одно из нескольких. / when you compare and pick one from several.' },
    { term: 'отложить / set aside', definition: 'не потратить сейчас, оставить на цель. / not spend now, save for a goal.' },
    { term: 'остаток / remaining', definition: 'сколько нимов осталось после выбора. / how many nims are left after the choice.' },
    { term: 'лавка / small shop', definition: 'место, где можно сравнить и выбрать. / a place to compare and choose.' },
    { term: 'полезный / useful', definition: 'то, что помогает в учёбе или дома. / something that helps at school or at home.' }
  ],
  onlineTasks: [
    {
      id: 'q_w1',
      type: 'math',
      title: 'Разогрев 1 / Warm-up 1',
      prompt:
        'Разогрейся: 40 − 18 − 6 = ? / Warm up: 40 − 18 − 6 = ?',
      helper:
        'Сначала 40 − 18 = 22, потом 22 − 6. / First 40 − 18 = 22, then 22 − 6.',
      answer: '16',
      unit: 'нимов / nims'
    },
    {
      id: 'q_w2',
      type: 'math',
      title: 'Разогрев 2 / Warm-up 2',
      prompt: 'Разогрейся: 3 × 7 = ? / Warm up: 3 × 7 = ?',
      helper: 'Таблица умножения на 3. / Times table for 3.',
      answer: '21',
      unit: 'нимов / nims'
    },
    {
      id: 'q1',
      type: 'math',
      title: 'Процент и дробь / Percent and Fraction',
      prompt:
        'У Нимни 240 нимов. 35% она тратит на книгу. Затем 1/4 оставшейся суммы — на материалы для лавки. Сколько нимов осталось? / Nimny has 240 nims. She spends 35% on a book. Then 1/4 of what is left goes to shop materials. How many nims remain?',
      helper:
        'Что сделать: 1) найди 35% от 240; 2) вычти; 3) от остатка найди 1/4 и снова вычти. Ответ — число. / What to do: 1) find 35% of 240; 2) subtract; 3) take 1/4 of what is left and subtract again. Answer = a number.',
      answer: '117',
      unit: 'нимов / nims'
    },
    {
      id: 'q2',
      type: 'math',
      title: 'Уравнение / Equation',
      prompt:
        'Нимни купила 3 одинаковых набора и ещё книгу за 18 нимов. Всего она потратила 72 нима. Сколько стоит один набор? / Nimny bought 3 identical sets plus a book for 18 nims. She spent 72 nims total. How much is ONE set?',
      helper:
        'Что сделать: составь уравнение 3x + 18 = 72, найди x. / What to do: write 3x + 18 = 72 and solve for x.',
      answer: '18',
      unit: 'нимов / nims'
    },
    {
      id: 'q3',
      type: 'math',
      title: 'Сравнение бюджетов / Budget comparison',
      prompt:
        'Бюджет 200 нимов. Сравни 3 варианта и запиши остаток лучшего:\nA) книга 60 + материалы 35% бюджета + подарок 18.\nB) книга 60 + материалы 1/4 бюджета + подарок 18.\nC) книга 60 + материалы 80 + подарок 18.\nКакой вариант оставляет больше всего нимов? Запиши остаток лучшего варианта. / Budget 200 nims. Compare 3 options and write the best remaining: A) book 60 + materials 35% of budget + gift 18; B) book 60 + materials 1/4 of budget + gift 18; C) book 60 + materials 80 + gift 18. Which option leaves the most? Write the remaining of the best one.',
      helper:
        'Что сделать: посчитай остаток каждого варианта (бюджет минус все расходы) и выбери самый большой остаток. / What to do: compute the remaining for each option (budget minus total spend) and pick the largest.',
      answer: '72',
      unit: 'нимов / nims'
    },
    {
      id: 'q_s1',
      type: 'math',
      title: 'Растяжка 1 / Stretch 1',
      prompt:
        'Найди 1/10 от 240 нимов. / Find 1/10 of 240 nims.',
      helper:
        '1/10 — это «одна десятая»: 240 ÷ 10. / 1/10 means one-tenth: 240 ÷ 10.',
      answer: '24',
      unit: 'нимов / nims'
    },
    {
      id: 'q_s2',
      type: 'math',
      title: 'Растяжка 2 / Stretch 2',
      prompt:
        'Найди 12.5% от 80 нимов. / Find 12.5% of 80 nims.',
      helper:
        '12.5% — это 1/8: 80 ÷ 8. / 12.5% equals 1/8: 80 ÷ 8.',
      answer: '10',
      unit: 'нимов / nims'
    },
    {
      id: 'q4',
      type: 'classify',
      title: 'Слова миссии: безударные гласные / Mission words: unstressed vowels',
      prompt:
        'Какая безударная гласная пишется в корне? / Which unstressed vowel is written in the root?',
      categories: [
        { id: 'o', label: 'пишем «о» / write "о"' },
        { id: 'a', label: 'пишем «а» / write "а"' },
        { id: 'e', label: 'пишем «е» / write "е"' }
      ],
      items: [
        { id: 'voda', text: 'в_да — проверка: воды / "voda" — check: voды' },
        { id: 'cena', text: 'ц_на — проверка: цены / "tsena" — check: цены' },
        { id: 'lavka', text: 'л_вка — проверка: лавки / "lavka" — check: лавки' },
        { id: 'gora', text: 'г_ра — проверка: горы / "gora" — check: горы' },
        { id: 'lesa', text: 'л_са — проверка: лес / "lesa" — check: лес' },
        { id: 'snega', text: 'сн_га — проверка: снег / "snega" — check: снег' }
      ]
    },
    {
      id: 'q_corr',
      type: 'text',
      title: 'Исправь ошибки / Correct the mistakes',
      prompt:
        'Перепиши без ошибок: «дениги помогают выбiрать. сначяла падумай что нужно а потом што хочеться.» Подсказка: безударные гласные проверяй ударением; не забудь заглавную букву и точки. / Rewrite without mistakes: "дениги помогают выбiрать. сначяла падумай что нужно а потом што хочеться." Hint: check unstressed vowels with a stressed form; mind capital letters and periods.',
      placeholder:
        'Деньги помогают выбирать. Сначала подумай, что нужно, а потом что хочется. / Money helps us choose...'
    },
    {
      id: 'q5',
      type: 'text',
      title: 'Мини-диктант / Mini-dictation',
      prompt:
        'Запиши без ошибок: «Деньги помогают выбирать. Сначала подумай, что нужно, а потом что хочется.» / Write without mistakes: "Money helps us choose. First think about what is needed, then about what is wanted."',
      placeholder:
        'Деньги помогают выбирать. ... / Money helps us choose. ...'
    },
    {
      id: 'q6',
      type: 'text',
      title: 'План текста и письмо / Text plan and writing',
      prompt:
        'Прочитай короткий текст: «Раньше люди менялись вещами: яблоко за хлеб. Это «обмен». Но иногда у пекаря не было того, что нужно. Тогда придумали деньги — общий знак. Деньги помогают сравнивать цены и выбирать.» Запиши план из 3 пунктов и 3–5 предложений на русском по теме: «Как деньги помогают выбирать?» / Read the short text: "Long ago people exchanged things: an apple for bread. That is «exchange». But sometimes the baker did not have what was needed. So people invented money — a common sign. Money helps us compare prices and choose." Write a 3-point plan and 3–5 Russian sentences on: "How does money help us choose?"',
      placeholder:
        '1. ... 2. ... 3. ... Мои предложения: ... / 1. ... 2. ... 3. ... My sentences: ...'
    },
    {
      id: 'q_obs',
      type: 'text',
      title: 'Наблюдение и логика — как выбор меняет остаток / Observation and Logic — How Choice Changes What Is Left',
      prompt:
        'Возьми один бюджет 50 нимов и посчитай остаток для каждого варианта:\nВариант 1 (только «нужно»): вода 10 + тетрадь 12 + ручка 8.\nВариант 2 (больше «хочу»): вода 10 + игрушка 18 + сладкая закуска 12.\nВариант 3 («нужно» + «отложить»): вода 10 + тетрадь 12 + отложить 10.\nЗапиши остатки для трёх вариантов и сделай вывод одной фразой: что меняется и что остаётся одинаковым. / Take a 50-nim budget and compute the remaining for each option (only "needs", more "wants", "needs" + "save"). Write three remainders and one conclusion sentence: what changes and what stays the same.',
      placeholder:
        'Вариант 1: ____ нимов. Вариант 2: ____ нимов. Вариант 3: ____ нимов. Вывод: ... / Option 1: ____. Option 2: ____. Option 3: ____. Conclusion: ...'
    },
    {
      id: 'q7',
      type: 'classify',
      title: 'Лавка Нимни: 5 корзин / Nimny Shop: 5 baskets',
      prompt:
        'Разложи карточки лавки по 5 корзинам. «Нужно/Хочу/Отложить» — про твой выбор. «Цена» — карточки, где главное число-стоимость. «Обмен» — когда одно меняют на другое. / Sort the shop cards into 5 baskets. Need/Want/Save are about your choice. Price = cards where the price is the main idea. Exchange = when one thing is traded for another.',
      categories: [
        { id: 'need', label: 'Нужно / Need' },
        { id: 'want', label: 'Хочу / Want' },
        { id: 'price', label: 'Цена / Price' },
        { id: 'exchange', label: 'Обмен / Exchange' },
        { id: 'save', label: 'Отложить / Save' }
      ],
      items: [
        { id: 'water', text: 'вода / water' },
        { id: 'notebook', text: 'тетрадь / notebook' },
        { id: 'toy', text: 'игрушка / toy' },
        { id: 'gift', text: 'подарок маме / gift for mom' },
        { id: 'book', text: 'полезная книга / useful book' },
        { id: 'save5', text: 'отложить 5 нимов / set aside 5 nims' },
        { id: 'snack', text: 'сладкая закуска / sweet snack' },
        { id: 'pen', text: 'ручка для уроков / pen for school' },
        { id: 'price-tag', text: 'ценник «тетрадь — 12 нимов» / price tag "notebook — 12 nims"' },
        { id: 'apple-bread', text: 'яблоко поменяли на хлеб / an apple traded for bread' }
      ]
    },
    {
      id: 'q8',
      type: 'text',
      title: 'Мой план лавки / My shop plan',
      prompt:
        'У тебя 50 нимов. Запиши: одно «нужно», одно «хочу», один полезный предмет и сколько отложить. Объясни одной фразой главный выбор. / You have 50 nims. Write: one "need", one "want", one useful item, and how many nims to set aside. Explain your main choice in one sentence.',
      placeholder:
        'Нужно: ... Хочу: ... Полезное: ... Отложить: ... Главный выбор: ... / Need: ... Want: ... Useful: ... Save: ... Main choice: ...'
    },
    {
      id: 'q9',
      type: 'essay',
      title: 'Дневник мышления: один умный выбор / Thinking diary: one smart choice',
      prompt:
        'Напиши 3–5 предложений: что я выбрал сегодня и почему это разумный выбор. Используй слова: цена, выбор, отложить, остаток. / Write 3–5 sentences: what I chose today and why it is a smart choice. Use words: price, choice, save, remaining.',
      minSentences: 3,
      maxSentences: 5,
      placeholder:
        'Сегодня я выбрал ... / Today I chose ...'
    }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 1, День 1 — Миссия монеток». / Heading: "Week 1, Day 1 — Coin Mission".',
    'Слой 1. Математика: запиши решения q1–q3 столбиком. / Layer 1. Math: write q1–q3 step by step.',
    'Слой 2. Русский язык: запиши словарь миссии и мини-диктант. / Layer 2. Russian: write the mission vocabulary and the mini-dictation.',
    'Слой 3. Чтение и пересказ: 3-пунктовый план + 3–5 предложений; перескажи родителю. / Layer 3. Reading and retelling: 3-point plan + 3–5 sentences; retell to a parent.',
    'Слой 4. Наблюдение и логика: запиши, как меняется остаток при разных выборах. / Layer 4. Observation and Logic: write how the remaining amount changes for different choices.',
    'Слой 5. Практика: запиши план лавки на 50 нимов. / Layer 5. Practice: write the shop plan for 50 nims.',
    'Дневник мышления: один умный выбор и почему. / Thinking diary: one smart choice and why.',
    'Награда нимами начисляется после проверки родителем. / Reward in nims is added after a parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 1, День 1 / Week 1, Day 1',
    subtitle: 'Миссия монеток: лавка Нимни / Coin Mission: Nimny Shop',
    pages: [
      {
        title: 'Маршрут миссии — Лавка Нимни / Mission Route — Nimny Shop',
        blocks: [
          { type: 'text', text: 'Сегодня — пять слоёв и одна миссия. Отмечай ☐ → ☑, когда шаг готов. / Today — five layers and one mission. Mark ☐ → ☑ when a step is done.' },
          { type: 'list', items: [
            '☐ Слой 1. Математика — около 10 минут. / Layer 1. Math — about 10 minutes.',
            '☐ Слой 2. Русский язык — около 10 минут. / Layer 2. Russian — about 10 minutes.',
            '☐ Слой 3. Чтение и пересказ — около 10 минут. / Layer 3. Reading and retelling — about 10 minutes.',
            '☐ Слой 4. Наблюдение и логика — около 5 минут. / Layer 4. Observation and Logic — about 5 minutes.',
            '☐ Слой 5. Практика на бумаге — около 15 минут. / Layer 5. Paper practice — about 15 minutes.',
            '☐ Дневник мышления — 5 минут. / Thinking diary — 5 minutes.',
            '☐ Печать миссии и награда нимами. / Mission stamp and nim reward.'
          ]}
        ]
      },
      {
        title: 'Слой 1. Математика — проценты, дроби и уравнение / Layer 1. Math — Percent, Fraction and Equation',
        blocks: [
          { type: 'text', text: 'Решай в нимах. Записывай ход решения по шагам. / Solve in nims. Show your steps.' },
          { type: 'list', items: [
            '1) Процент + дробь: у Нимни 240 нимов. 35% → книга. От остатка 1/4 → материалы. Остаток = ? / 240 → 35% → book; remainder → 1/4 → materials.',
            '   Шаг 1: 35% × 240 = ____ . Остаток = 240 − ____ = ____. / Step 1.',
            '   Шаг 2: 1/4 × ____ = ____ . Конечный остаток = ____ − ____ = ____ нимов / nims.',
            '2) Уравнение: 3 одинаковых набора + книга 18 нимов = 72. Найди цену набора. / Equation.',
            '   3x + 18 = 72  →  3x = ____  →  x = ____ нимов / nims.',
            '3) Сравнение бюджетов (бюджет 200). Запиши остаток для A, B, C: / Compare 3 budget options (budget 200).',
            '   A) 200 − 60 − 0.35·200 − 18 = ____',
            '   B) 200 − 60 − (1/4)·200 − 18 = ____',
            '   C) 200 − 60 − 80 − 18 = ____',
            '   Лучший вариант: ____ , остаток: ____ нимов / Best: ___, remaining: ___ nims.',
            '4) Warm-up (разогрев): 40 − 18 − 6 = ____ ; 3 × 7 = ____ .',
            '5) Растяжка: 1/10 от 240 нимов = ____ ; 12.5% от 80 = ____ . / Stretch.'
          ]}
        ]
      },
      {
        title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling',
        blocks: [
          { type: 'text', text: 'Правило дня: безударные гласные в корне проверяем ударением (вода — воды). / Rule of the day: check unstressed root vowels with a stressed form (вода — воды).' },
          { type: 'list', items: [
            'Словарь миссии: деньги, цена, обмен, нужно, хочу, выбор, отложить, остаток, лавка, полезный. / Mission vocabulary.',
            'Мини-диктант: «Деньги помогают выбирать. Сначала подумай, что нужно, а потом что хочется.» / Mini-dictation: "Money helps us choose..."',
            'Запиши без ошибок: __________________________________________ / Write without mistakes:',
            'Исправление (отметь и перепиши): «дениги помогают выбiрать. сначяла падумай что нужно а потом што хочеться.» / Correct and rewrite the sentence with mistakes.',
            'Подчеркни проверяемые гласные в словах: вода, цена, лавка. / Underline the checked vowels in the words.'
          ]}
        ]
      },
      {
        title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling',
        blocks: [
          { type: 'text', text: 'Прочитай короткий текст и сделай план. / Read the short text and make a plan.' },
          { type: 'list', items: [
            'Текст: «Раньше люди менялись вещами: яблоко за хлеб. Это «обмен». Но иногда у пекаря не было того, что нужно. Тогда придумали деньги — общий знак. Деньги помогают сравнивать цены и выбирать.» / Text: "Long ago people exchanged things..."',
            'План: 1) ____________________  2) ____________________  3) ____________________ / Plan',
            'Главная мысль: ______________________________________ / Main idea',
            'Мои 3–5 предложений «Как деньги помогают выбирать?»: / My 3–5 sentences "How does money help us choose?"',
            '1. ______________________________________________',
            '2. ______________________________________________',
            '3. ______________________________________________',
            '☐ Я пересказал родителю / I retold a parent.'
          ]}
        ]
      },
      {
        title: 'Слой 4. Наблюдение и логика — как выбор меняет остаток / Layer 4. Observation and Logic — How Choice Changes What Is Left',
        blocks: [
          { type: 'text', text: 'Сравни три варианта одного бюджета 50 нимов и понаблюдай, что меняется. / Compare three options of the same 50-nim budget and observe what changes.' },
          { type: 'list', items: [
            'Вариант 1: только «нужно». Остаток = ____ нимов / Option 1: only "needs". Remaining = ____ nims.',
            'Вариант 2: больше «хочу». Остаток = ____ нимов / Option 2: more "wants". Remaining = ____ nims.',
            'Вариант 3: «нужно» + «отложить». Остаток = ____ нимов / Option 3: "needs" + "save". Remaining = ____ nims.',
            'Что меняется при разных выборах? ____________________ / What changes with different choices?',
            'Что остаётся одинаковым? ____________________ / What stays the same?',
            'Мой вывод (1 фраза): ____________________ / My conclusion (1 line):'
          ]}
        ]
      },
      {
        title: 'Слой 5. Практика на бумаге — Карточки лавки Нимни / Layer 5. Paper Practice — Nimny Shop Cards',
        blocks: [
          { type: 'text', text: 'Нарежь или отметь карточки. Разложи их в 5 корзин. / Cut or mark the cards. Sort them into 5 baskets.' },
          { type: 'list', items: [
            'Корзины: «Нужно», «Хочу», «Цена», «Обмен», «Отложить». / Baskets: Need, Want, Price, Exchange, Save.',
            'Карточки: вода, тетрадь, игрушка, подарок, книга, отложить 5 нимов, сладкая закуска, ручка. / Cards: water, notebook, toy, gift, book, save 5 nims, snack, pen.',
            '☐ Обведи две карточки «Нужно». / Circle two "Need" cards.',
            '☐ Обведи одну карточку «Хочу». / Circle one "Want" card.',
            '☐ Выбери, на что отложить. / Choose what to save for.',
            '☐ Объясни родителю один свой выбор. / Explain one of your choices to a parent.',
            'Мой план лавки на 50 нимов: / My 50-nim shop plan:',
            'Нужно: ____________________ (____ нимов) / Need',
            'Хочу: ____________________ (____ нимов) / Want',
            'Полезное: ____________________ (____ нимов) / Useful',
            'Отложить: ____________________ (____ нимов) / Save',
            'Итого: ____ нимов из 50. / Total of 50.'
          ]}
        ]
      },
      {
        title: 'Дневник мышления / Thinking Diary',
        blocks: [
          { type: 'list', items: [
            'Самый умный выбор сегодня: ______________________ / My smartest choice today',
            'Я выбрал так, потому что _________________________ / I chose this because',
            'Слово миссии, которое запомнилось: ________________ / Mission word I remember'
          ]}
        ]
      },
      {
        title: 'Родительская проверка, печать миссии и награда нимами / Parent Check, Mission Stamp and Nim Reward',
        blocks: [
          { type: 'text', text: 'После проверки начисли бонусные нимы через Parent Room. / After checking, add bonus nims through Parent Room.' },
          { type: 'list', items: [
            'Базовая награда: 3 нима ☐ / Base reward: 3 nims ☐',
            'Бонус за разумный выбор: +1 ☐ / Smart-choice bonus: +1 ☐',
            'Бонус за ясное объяснение по-русски: +1 ☐ / Clear-Russian-explanation bonus: +1 ☐',
            'Итого: ____ из 5 нимов. / Total ____ of 5 nims.',
            'Печать миссии (родитель): ☐ / Mission stamp (parent): ☐',
            'Подпись родителя: ____________________ / Parent signature'
          ]}
        ]
      }
    ]
  },
  parentGuide: {
    goal:
      'Сегодня сбалансированный день из пяти слоёв вокруг денег и выбора. Цель — восстановить базу: что такое деньги, цена, нужно/хочу, остаток и зачем откладывать. / Today is a balanced 5-layer day around money and choice. The goal is to rebuild the base: money, price, need/want, remaining and why we save.',
    mathGoal:
      'Проценты (35% от 240 = 84), дробь от остатка (1/4 × 156 = 39), уравнение 3x + 18 = 72 и сравнение остатков трёх вариантов бюджета. / Percent (35% of 240), fraction of remainder (1/4 of 156), equation 3x + 18 = 72, and comparing three budget remainders.',
    russianGoal:
      'Безударные гласные в корне; правильно записанный мини-диктант; исправлены ошибки в 3–5 коротких предложениях. / Unstressed root vowels; correct mini-dictation; 3–5 short sentences corrected.',
    readingWritingGoal:
      'План из 3 пунктов; пересказ родителю; 3–5 предложений на русском по теме «как деньги помогают выбирать». / 3-point plan; retell to a parent; 3–5 Russian sentences on "how money helps us choose".',
    practicalGoal:
      'Карточки нужно/хочу/отложить разложены; ребёнок написал маленький план лавки на 50 нимов и объяснил один выбор. / Need/want/save cards sorted; child wrote a small 50-nim shop plan and explained one choice.',
    observationGoal:
      'Ребёнок сравнил 3 варианта одного бюджета и сделал короткий вывод: «больше хочу — меньше остаток; отложить — есть цель». / Child compared 3 options of the same budget and concluded: "more wants → smaller remaining; saving → there is a goal".',
    check: [
      'Q1: 117 нимов (35% и 1/4 поэтапно). Q2: x = 18 (уравнение). Q3: лучший вариант B, остаток 72. / Q1: 117 step by step. Q2: x = 18. Q3: B = 72.',
      'Мини-диктант записан без грубых ошибок. / Mini-dictation written without major mistakes.',
      'План текста — 3 пункта; пересказ — 3–5 предложений по-русски. / Plan = 3 points; retell = 3–5 Russian sentences.',
      'Карточки разложены по 5 корзинам; обведены 2 «нужно» и 1 «хочу». / Cards sorted into 5 baskets; 2 "needs" and 1 "want" circled.',
      'План лавки на 50 нимов аккуратен и не превышает бюджет. / 50-nim plan is tidy and within budget.',
      'Дневник мышления заполнен; есть один умный выбор. / Thinking diary filled; one smart choice noted.'
    ],
    answerKey: [
      { taskId: 'q_w1', answer: '16 нимов. Шаг: 40 − 18 = 22; 22 − 6 = 16. Parent note: разогрев — без листка, считаем устно. / Warm-up: 40 − 18 = 22; 22 − 6 = 16.' },
      { taskId: 'q_w2', answer: '21 ним. Шаг: 3 × 7 = 21. Таблица умножения на 3. / 3 × 7 = 21.' },
      { taskId: 'q1', answer: '117 нимов. Решение: 35% × 240 = 84; 240 − 84 = 156; 1/4 × 156 = 39; 156 − 39 = 117. Parent note: если трудно — найди 10% (24), потом 30% (72), плюс 5% (12) = 84. / Steps: 84; 156; 39; 117. Parent: scaffold via 10% then 5%.' },
      { taskId: 'q2', answer: '18 нимов. Решение: 3x + 18 = 72 → 3x = 54 → x = 18. Parent note: «лишние 18» — это книга, её вычитаем; остаток делим поровну на 3 набора. / Equation: 3x + 18 = 72; subtract 18; divide by 3.' },
      { taskId: 'q3', answer: 'Лучший — вариант B, остаток 72. Решение: A) 200 − 60 − 70 − 18 = 52; B) 200 − 60 − 50 − 18 = 72; C) 200 − 60 − 80 − 18 = 42. Parent note: 35% от 200 = 70, 1/4 от 200 = 50. / Best B = 72.' },
      { taskId: 'q_s1', answer: '24 нима. 1/10 от 240 = 240 ÷ 10 = 24. Parent note: «одна десятая» — это деление на 10. / 1/10 of 240 = 24.' },
      { taskId: 'q_s2', answer: '10 нимов. 12.5% = 1/8; 80 ÷ 8 = 10. Parent note: дробь полезнее процента, когда 12.5% = 1/8. / 12.5% of 80 = 10 (via 1/8).' },
      { taskId: 'q4', answer: 'вода — о, цена — е, лавка — а, гора — о, леса — е, снега — е (проверки: воды, цены, лавки, горы, лес, снег). Parent note: безударные гласные в корне всегда проверяем ударением. / Vowels by check word.' },
      { taskId: 'q_corr', answer: '«Деньги помогают выбирать. Сначала подумай, что нужно, а потом что хочется.» Что исправлено: дениги→деньги (безударная «е»), выбiрать→выбирать (русская «и»), сначяла→сначала (нет «ча/чу» с «я»), падумай→подумай (безударная «о», проверка: думать), что хочеться→что хочется (на вопрос «что делает?» — без мягкого знака), заглавная буква и точки. / Corrections explained: each unstressed vowel checked; «что делает?» rule for verbs.' },
      { taskId: 'q5', answer: '«Деньги помогают выбирать. Сначала подумай, что нужно, а потом что хочется.» Parent note: проверь запятую перед «а», точки и заглавные буквы. / Mini-dictation answer with punctuation focus.' },
      { taskId: 'q6', answer: 'План — 3 пункта (1. Раньше обмен вещами; 2. Обмен трудный, потому что не всегда есть нужное; 3. Деньги — общий знак, помогают сравнивать и выбирать); 3–5 предложений по-русски. Parent note: главное — мысль «деньги делают сравнение проще», а не пересказ слово в слово. / Plan with 3 points (exchange → problem → money as common sign); 3–5 Russian sentences.' },
      { taskId: 'q_obs', answer: 'Вариант 1: 50 − 10 − 12 − 8 = 20. Вариант 2: 50 − 10 − 18 − 12 = 10. Вариант 3: 50 − 10 − 12 − 10 = 18. Вывод: чем больше «хочу», тем меньше остаток; «отложить» сохраняет нимы на цель — остаток как будто больше, потому что часть уже работает на будущее. Parent note: принимать любой осмысленный вывод про связь «хочу ↑ → остаток ↓». / Remainders 20/10/18; conclusion about wants vs save.' },
      { taskId: 'q7', answer: 'Need: вода, тетрадь, ручка. Want: игрушка, подарок маме, сладкая закуска. Save: отложить 5 нимов. Price: ценник «тетрадь — 12 нимов». Exchange: яблоко поменяли на хлеб. «Полезная книга» — допускается «нужно» или «отложить» с объяснением. Parent note: 5-я и 4-я корзины — концепты («Цена» = там, где главное число-стоимость; «Обмен» = когда одно меняют на другое). / Need/Want/Save by item; Price = price-tag card; Exchange = trade card; "useful book" flexible.' },
      { taskId: 'q8', answer: 'Открытый ответ. Принимать, если: 1 нужно, 1 хочу, 1 полезное, есть «отложить», итог ≤ 50 нимов и ребёнок объясняет главный выбор. Parent note: попроси назвать, ПОЧЕМУ это его главный выбор. / Open answer; accept if structure is correct and child explains the main choice.' },
      { taskId: 'q9', answer: 'Открытый ответ. 3–5 предложений со словами: цена, выбор, отложить, остаток. Parent note: проверить, что все 4 слова реально использованы. / Open answer with the required 4 words actually used.' }
    ],
    spellingCheck:
      'Безударные гласные в корне проверяются ударением. Принимать, если найдены и проверены гласные хотя бы в 4 словах из 6. / Accept if at least 4 of 6 unstressed vowels are checked correctly.',
    readingCheck:
      'План — 3 пункта, ребёнок пересказывает по-русски без чтения с листа. / 3-point plan; retell in Russian without reading.',
    practicalCheck:
      'Сортировка карточек логична; план лавки укладывается в 50 нимов; есть «отложить»; ребёнок объясняет один выбор. / Sorting is logical; plan within 50 nims; "save" present; child explains one choice.',
    observationCheck:
      'Записаны 3 остатка для 3 вариантов и сделан короткий вывод. / 3 remaining values written for 3 options + a short conclusion.',
    discussionPrompts: [
      'Что для тебя «нужно», а что «хочу»? Почему? / What is "need" and what is "want" for you? Why?',
      'Почему мы откладываем нимы, а не тратим всё сразу? / Why do we save some nims instead of spending all at once?',
      'Когда деньги помогают сравнивать, а когда мешают? / When does money help us compare, and when does it get in the way?'
    ],
    ifEasy:
      'Дай бюджет 80 нимов и список из 6 цен. Попроси найти 3 разных варианта в пределах бюджета и сравнить остатки. / Give an 80-nim budget and 6 prices; ask for 3 different options within the budget and compare remaining.',
    ifDifficult:
      'Возьми реальные бытовые предметы и положи рядом числа-ценники в нимах. Считайте вместе вслух. / Take real household items and put nim price tags next to them; count together aloud.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 3,
    max: 5,
    label: 'Награда за миссию',
    display: '3 нима',
    bonuses: [
      { id: 'smart-choice', label: 'Бонус за разумный выбор', amount: 1 },
      { id: 'clear-russian-answer', label: 'Бонус за ясное объяснение по-русски', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: ['q1', 'q4', 'q6', 'q7', 'q9'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'max-week-1-day-2'
};

export default day1;
